import request from '@/utils/request'


// 查询用户心率记录列表
export function listHeartRecord(query) {
  return request({
    url: '/joe/user-heart-record/list',
    method: 'get',
    params: query
  })
}

// 查询用户心率记录分页
export function pageHeartRecord(query) {
  return request({
    url: '/joe/user-heart-record/page',
    method: 'get',
    params: query
  })
}

// 查询用户心率记录详细
export function getHeartRecord(data) {
  return request({
    url: '/joe/user-heart-record/detail',
    method: 'get',
    params: data
  })
}

// 新增用户心率记录
export function addHeartRecord(data) {
  return request({
    url: '/joe/user-heart-record/add',
    method: 'post',
    data: data
  })
}

// 修改用户心率记录
export function updateHeartRecord(data) {
  return request({
    url: '/joe/user-heart-record/edit',
    method: 'post',
    data: data
  })
}

// 删除用户心率记录
export function delHeartRecord(data) {
  return request({
    url: '/joe/user-heart-record/delete',
    method: 'post',
    data: data
  })
}
